import script from "./PersonalFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalFeedback.vue?vue&type=script&setup=true&lang=js"

import "./PersonalFeedback.vue?vue&type=style&index=0&id=8750ed5a&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8750ed5a"]])

export default __exports__